import { action, makeObservable, observable } from 'mobx';

/**
 * F-0584 MWI-15 (I-1935): what a Join from the person's own list says when it skipped a place — the
 * places joined, and one line per place not added with its reason.
 *
 * Held outside `PendingInvitations` because the Join itself unmounts it: on "No work areas yet" the
 * first work area arrives and the empty state that drew the list is gone, taking the lines with it.
 * Mounted once (`InvitationJoinedNotice`, in `Layout.tsx`), and it stays until the person dismisses
 * it: a skipped place is never dropped on a timer.
 */
export interface IInvitationJoinedNotice {
  /** The places joined, in words: "Checkout app and Support". */
  readonly places: string;
  /** "Not added to Billing: <reason>.", one per skipped place. */
  readonly skipped: readonly string[];
  /** PX-14 (principle review 32): a customer's invitation says the agency's name, not the places. */
  readonly agency?: string | null;
  /** Principle review 31: an invitation the sign-up could not open, said with why and what to do. */
  readonly refusal?: string | null;
}

export class InvitationJoinedNoticeStore {
  notice: IInvitationJoinedNotice | null = null;

  constructor() {
    makeObservable(this, {
      notice: observable.ref,
      show: action,
      dismiss: action,
    });
  }

  show(notice: IInvitationJoinedNotice): void {
    this.notice = notice;
  }

  dismiss(): void {
    this.notice = null;
  }
}

export const invitationJoinedNotice = new InvitationJoinedNoticeStore();
